






























































































































import { Component, Vue, Prop, Emit, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskDate } from '@/utils/common'
import { Carater } from '@/types/interfaces/Solicitacao'

@Component
export default class ComponentBackofficeProtocoloOperadora extends Vue {
  @Prop({ required: false }) label
  @Prop({ required: false, default: false }) disabled: boolean

  protocoloOperadoraForm: any = {
    valid: true,
    protocoloOperadora: [
      v => !!v || 'Campo obrigatório.',
    ],
  }

  @Emit('resendAuthorization')
  resendAuthorization() {}

  @Watch('getBackofficeGlobalStore.modal.iniciarProcesso', { immediate: true })
  async onModalIniciarProcessoOpen(isOpen) {
    if (isOpen
      && this.getBackofficeGlobalStore.solicitacao.id
      && this.getBackofficeGlobalStore.solicitacao.acoes.autorizacaoResolveErroIntegracaoOperadora
      && !this.hasOpme) {
      if (this.getBackofficeGlobalStore.solicitacao.numeroGuiaTissInternacao) {
        this.initialValuesManualAuthorizationForm.numeroGuiaTissInternacao = this.getBackofficeGlobalStore.solicitacao.numeroGuiaTissInternacao
      }

      if (this.getBackofficeGlobalStore.solicitacao.numeroGuiaTissOpme) {
        this.initialValuesManualAuthorizationForm.numeroGuiaTissOpme = this.getBackofficeGlobalStore.solicitacao.numeroGuiaTissOpme
      }
    }
  }

  onNumeroGuiaTissChange(newValue) {
    if (this.initialValuesManualAuthorizationForm.numeroGuiaTissInternacao === this.getBackofficeGlobalStore.solicitacao.numeroGuiaTissInternacao
      && this.initialValuesManualAuthorizationForm.numeroGuiaTissOpme === this.getBackofficeGlobalStore.solicitacao.numeroGuiaTissOpme) {
      this.$emit('resendAuthorization', true)
    } else {
      this.$emit('resendAuthorization', false)
    }
  }

  initialValuesManualAuthorizationForm: {
    numeroGuiaTissInternacao: string,
    numeroGuiaTissOpme: string,
  } = {
    numeroGuiaTissInternacao: '',
    numeroGuiaTissOpme: '',
  }

  manualAuthorizationForm: any = {
    valid: false,
    numeroGuiaTissInternacao: [v => !!v || 'Campo obrigatório.'],
    numeroGuiaTissOpme: [this.hasOpme ? v => !!v || 'Campo obrigatório.' : () => true],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get hasOpme() {
    return this.getBackofficeGlobalStore.solicitacao.temOpme
  }

  get getDataAutorizacao() {
    if (this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade) {
      return maskDate(this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade)
    }
    return ''
  }

  set getDataAutorizacao(value: string) {
    this.getBackofficeGlobalStore.setAutorizacaoValidade(value)
  }


  get surgerySolicitationHasUrgencyAutorizationEnabled() {
    return this.getBackofficeGlobalStore.solicitacao.utilizaAnalisePreAutorizacaoUrgencia
      && this.getBackofficeGlobalStore.solicitacao.utilizaAguardandoAutorizacaoUrgencia
      && this.surgeryType && this.surgeryType.key === 'Urgencia'
      && (this.surgeryStatus === 'AguardandoAutorizacaoUrgencia' || this.surgeryStatus === 'AnalisePreAutorizacaoUrgencia')
  }

  get surgeryType() {
    return this.getBackofficeGlobalStore.solicitacao.carater as Carater
  }

  get surgeryStatus() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key
  }
}
